import { createUseStyles } from 'react-jss';

import { mediaQuery } from '../../../styles/helpers';
import { ITheme } from '../../../styles/theme';

const cssMap = {
  up: {
    top: 'calc(100% + 8px)',
  },
  down: {
    bottom: 'calc(100% + 8px)',
  },
};

export default createUseStyles<string, { position: 'up' | 'down' }>(
  ({ breakpoints }: ITheme) => ({
    root: {
      display: 'inline-block',
      position: 'relative',
      width: 'fit-content',

      '&:hover $tooltip': {
        display: 'inline-block',

        [mediaQuery(breakpoints.tablet)]: {
          display: 'none',
        },
      },
    },
    tooltip: ({ position }) => ({
      display: 'none',
      left: '50%',
      position: 'absolute',
      transform: 'translateX(-50%)',
      width: 'max-content',
      zIndex: 1,
      ...cssMap[position],
    }),
  }),
  { name: 'WithTooltip' },
);
